var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 1002.667,
    viewBox: "0 0 1050 752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 376v376h264.9c145.8 0 265.2-.3 265.5-.8.2-.4.2-49.2-.1-108.5l-.6-107.7H378.5c-83.2 0-152.7-.3-154.4-.6l-3.1-.7V485h236V268H221v-49.7l15.2-.6c8.3-.4 77.8-.7 154.3-.7h139.2l.5-107.8c.3-59.2.4-108 .1-108.5-.2-.4-119.6-.7-265.4-.7H0v376zM898.8 240c-17.5 1.4-31.8 4.9-47.8 12-17.8 7.8-32.2 17.9-47.2 32.7l-9.8 9.7v-41.7l-55.7.6c-30.6.4-71.5.7-91 .7H612v497h182V572.2c0-164.5.1-179 1.7-181.2 6.1-9.3 14.3-14.1 25-14.8 16-1 24.9 5.5 30.2 22.3 1.4 4.5 1.6 24 1.8 179.2L853 752h196l.2-188.8c.2-103.8 0-193.4-.4-199.2-4.2-59.1-35.2-101.6-86-117.9-18.5-5.9-40.3-8-64-6.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageEn);
export default __webpack_public_path__ + "static/media/language-en.20845091d515f3ccba01a715d3b2a26b.svg";
export { ForwardRef as ReactComponent };